import { get, makeAutoObservable } from "mobx";
import { guidanceForEmissionActivityAPI } from "../../GuidanceForEmissionActivity/guidanceForEmissionActivityAPI";
import {
  handleAPIError,
  MESSAGE_CODES,
  showErrorToast,
  showSuccessToast,
} from "../../services/toast";
import commonStore from "./commonStore";
import { importJobAPI } from "../../ExcelImportExportModal/API/importJobAPI";
const {
  getSchoolBasicInfo,
  getIndustryOptionInfo,
  getEmissionRegulatedIndustry,
  getAuthorityCode,
  getVerificationOrgCode,
  addSchoolBasicInfo,
  updateSchoolBasicInfo,
  getBoundarySite,
  getEmissionSetting,
  getActivityList,
  updateBoundarySite,
  updateActivityData,
  updateTestingMethodAndDate,
  updateNewEmissionSource,
  getMaterialOptionInfo,
  getEquipmentOptionInfo,
  getUnitDepartment,
  updateUnitDepartment,
  downloadBoundarySettingExcel,
  downloadActivityListExcel,
  uploadActivityListExcel,
  uploadBoundarySiteExcel,
  getEmissionSelectOptions,
  getFuelHeatCarbonSourceLookup,
  getLabAccreditationQualificationLookup,
  getTestingMethodLookup,
  getMeasurementFrequencyOptionInfo,
} = guidanceForEmissionActivityAPI;
//api
class GuidanceForEmissionActivityStore {
  //目前的指引頁面
  selectedPage = 0;
  //目前的指引子頁面
  selectedSubPage = 0;
  emissionSourcePagination = {
    page: 1,
    pageSize: 10,
  };
  //temp
  pendingPage = 0;

  //年份
  selectedYear = "2025";

  //選擇的公司(排放源設定)
  selectedSingleCom = "";

  //選擇的公司(新增排放源，我的排放源)
  selectedCom = "";

  //是否顯示警告視窗
  isShowBoundarySettingDescriptionModal = false;

  //在切換頁面或子頁面的時候註冊該頁面要使用的save行為
  pendingSaveHandler = null;

  //共用刪除modal
  isShowGFEADeleteModal = false;

  /////////////////////////////事業基本資料
  basicInfoData = this._generateDefaultBasicInfo();
  basicInfoId = null;
  basicInfoDataLoading = false;
  basicInfoErrors = {}; // 儲存驗證錯誤

  //行政院主計總處行業統計分類之行業代碼清單
  industryOptions = [];
  //「事業應盤查登錄溫室氣體排放量之排放源」之納管行業別及條件
  emissionRegulatedIndustryOptions = [];
  //目的事業主管機關清單
  authorityOptions = [];
  //檢驗機關清單
  verificationOptions = [];

  /////////////////////////////邊界設定

  boundarySiteData = [];
  modifiedRows = {}; // 修改過的列
  selectedOriginalRows = []; //被選取得原始列
  selectedCopiedRows = []; //被選取得複製列
  boundarySiteDataLoading = false;
  validationErrors = {}; // 儲存驗證錯誤
  requiredFields = [
    { key: "no", label: "分據點編號" },
    { key: "customer_company_name", label: "機構/校區/門市名稱" },
    { key: "authority_code", label: "目的事業主管機關編號" },
    { key: "authority_name", label: "目的事業主管機關名稱" },
    {
      key: "authority_certificate_no",
      label: "目的事業主管機關核發之證書字號",
    },
    { key: "unified_business_no", label: "統一編號" },
    { key: "can_get_power_account_no", label: "是否可取得電號" },
    { key: "city", label: "縣市別" },
    { key: "district", label: "鄉鎮市區" },
    { key: "address", label: "地址" },
    { key: "operating_start_date", label: "營業期間起日" },
    { key: "operating_end_date", label: "營業期間迄日" },
    { key: "address_description", label: "地址敘述" },
  ];
  keywordForBoundarySite = "";

  /////////////////////////////單位部門list
  unitDepartmentDataLoading = false;
  unitDepartmentData = [];
  unitDepartmentErrors = {};
  unitDepartmentModifiedRows = new Set();
  selectedUnitDepartmentRows = [];
  keywordForMyEmissionSource = "";

  /////////////////////////////排放源設定
  emissionSettingData = [];
  //modifiedEmissionSrtting = {}; // 修改過的資料
  modifiedEmissionStates = {};
  modifiedMaterialStates = {};
  emissionSettingDataLoading = false;

  /////////////////////////////新增排放源，我的排放源
  emissionActivityList = [];
  emissionActivityListLoading = false;
  selectedRows = [];

  emissionSelectOptions = []; //製程/逸散/外購電力類別總表

  /////////////////////////////新增排放源
  //目前list
  newEmissionSourceCurrentList = [];
  //修改列
  newEmissionSourceModifiedRows = new Set();
  //錯誤狀態
  newEmissionSourceErrors = {};

  /////////////////////////////活動數據
  //目前list
  activityDataCurrentList = [];
  //修改列
  activityDataModifiedRows = new Set();
  //錯誤狀態
  activityDataErrors = {};

  /////////////////////////////檢測方法及檢測日期
  //目前list
  testingMethodAndDateCurrentList = [];
  //修改列
  testingMethodAndDateModifiedRows = new Set();
  //錯誤狀態
  testingMethodAndDateErrors = {};

  //是否顯示匯入匯出視窗
  isShowGuidanceForEmissionActivityExcelModal = false;
  isExcelModalLoading = false;
  /////excelFile
  file = null;

  //是否顯示存檔警告視窗
  isShowGFEAWarningSaveModal = false;

  //排放源設定總表
  equipmentTypeCodeList = [];

  //原燃物料設定總表
  materialTypeCodeList = [];

  //量測頻率(下拉)選項
  measurementFrequencyOptions = [];

  //燃料熱值/碳含量來源(下拉)選項
  fuelHeatCarbonSourceLookupOptions = [];

  //實驗室/檢測機構認證資格(下拉)
  labAccreditationQualificationLookupOptions = [];

  //檢測方法(下拉)
  testMethodLookup = [];

  constructor() {
    makeAutoObservable(this);
  }

  ////////更新目前的指引頁面
  _handleSetSelectedPage = (page) => {
    this.selectedPage = page;
    this._handleSetSelectedSubPage(0);
  };

  ////////暫存指引頁面
  _handleSetPendingPage = (page) => {
    this.pendingPage = page;
    // this._handleSetSelectedSubPage(0);
  };

  ////////更新目前的指引子頁面
  _handleSetSelectedSubPage = (page) => {
    this.selectedSubPage = page;
  };

  _handleSetEmissionSourcePage = (page) => {
    this.emissionSourcePagination.page = page;
  };

  _handleSetEmissionSourcePageSize = (pageSize) => {
    this.emissionSourcePagination.pageSize = pageSize;
    this.emissionSourcePagination.page = 1;
  };

  _handleResetEmissionSourcePage = () => {
    this.emissionSourcePagination.page = 1;
  };

  /////更新目前的年份
  _handleSetSelectedYear = (year) => {
    const yearChanged = this.selectedYear !== year;
    this.selectedYear = year;
    if (yearChanged) this._handleResetEmissionSourcePage();
  };

  ////////更新新增排放源目前選擇的公司
  _handleSetSelectedSingleCom = (value) => {
    const companyChanged = this.selectedSingleCom !== value;
    this.selectedSingleCom = value;
    if (companyChanged) this._handleResetEmissionSourcePage();
  };

  ////////更新目前選擇的公司
  _handleSetSelectedCom = (value) => {
    const companyChanged = this.selectedCom !== value;
    this.selectedCom = value;
    if (companyChanged) this._handleResetEmissionSourcePage();
  };

  ////////開啟或關閉匯入匯出視窗
  _handleSetGuidanceForEmissionActivityExcelModal = (value) => {
    this.isShowGuidanceForEmissionActivityExcelModal = value;
  };

  ////////匯入匯出視窗是否有loading
  _handleSetExcelModalLoading = (value) => {
    this.isExcelModalLoading = value;
  };

  ////////更新file
  _handleSetFile = (data) => {
    this.file = data;
  };

  ////////開啟或關閉警告視窗
  _handleSetBoundarySettingDescriptionModal = (value) => {
    this.isShowBoundarySettingDescriptionModal = value;
  };

  ////////開啟或關閉存檔視窗
  _handleSetGFEAWarningSaveModal = (value) => {
    this.isShowGFEAWarningSaveModal = value;
  };

  ////////更新目前選擇的列
  _handleSetSelectedRows = (value) => {
    this.selectedRows = value;
    console.log("selectedRows", value);
  };

  _handleUnitDepartmentDataLoading = (value) => {
    this.unitDepartmentDataLoading = value;
  };

  /////////////////////////////共用下拉式清單選項
  //設備選項
  getEquipmentAll = async (year) => {
    this.equipmentTypeCodeList = [];
    try {
      const response = await getEquipmentOptionInfo(year);
      this.equipmentTypeCodeList = response;
    } catch (error) {
      console.error("Error fetching list", error);
    }
  };
  //原料選項
  getMaterialAll = async (year) => {
    this.materialTypeCodeList = [];
    try {
      const response = await getMaterialOptionInfo(year);
      this.materialTypeCodeList = response;
    } catch (error) {
      console.error("Error fetching list", error);
    }
  };

  //設定選項資料
  setOptionsData = (industry, emission, authority, verification) => {
    this.industryOptions = industry;
    this.emissionRegulatedIndustryOptions = emission;
    this.authorityOptions = authority;
    this.verificationOptions = verification;
  };

  //一次性抓取所有選項
  fetchAllOptions = async () => {
    // 防止重複抓取 (如果資料已經有了就不抓，看你需求)
    if (this.industryOptions.length > 0) return;
    try {
      // 使用 Promise.all 並行抓取，比你原本的一個個 await 更快
      const [industry, emission, authority, verification] = await Promise.all([
        getIndustryOptionInfo(),
        getEmissionRegulatedIndustry(),
        getAuthorityCode(),
        getVerificationOrgCode(),
      ]);
      this.setOptionsData(industry, emission, authority, verification);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  //負責將API資料轉換成選項格式
  get formattedAuthorityCodeOptions() {
    return this.authorityOptions.map(({ code }) => ({
      id: code,
      label: code,
      value: code,
    }));
  }

  get formattedAuthorityNameOptions() {
    return this.authorityOptions.map(({ code, name }) => ({
      id: code,
      label: name,
      value: name,
    }));
  }

  get formattedIndustryCodeOptions() {
    return this.industryOptions.map(({ code }) => ({
      id: code,
      label: code,
      value: code,
    }));
  }

  // 行業名稱選單
  get formattedIndustryNameOptions() {
    return this.industryOptions.map(({ code, name }) => ({
      id: code,
      label: name,
      value: name,
    }));
  }

  // 納管行業別 (原本那段複雜的 Map 邏輯)
  get formattedRegisteredIndustryOptions() {
    const uniqueIndustries = new Map();
    this.emissionRegulatedIndustryOptions.forEach((item) => {
      if (!uniqueIndustries.has(item.industry_name)) {
        uniqueIndustries.set(item.industry_name, item.industry_key);
      }
    });
    return Array.from(uniqueIndustries).map(([name, key]) => ({
      id: key,
      label: name,
      value: name,
    }));
  }

  // 4. Helper: 處理連動邏輯 (傳入 industryName 回傳對應的條件)
  getConditionsByIndustry = (industryName) => {
    if (!industryName) return [];

    return this.emissionRegulatedIndustryOptions
      .filter((item) => item.industry_name === industryName)
      .map((item, index) => ({
        id: `${item.industry_key}_${index}`,
        label: item.industry_conditions,
        value: item.industry_conditions,
      }));
  };

  // 檢驗機關清單名稱選單
  get formattedVerificationOrgCodeOptions() {
    return this.verificationOptions.map(({ code }) => ({
      id: code,
      label: code,
      value: code,
    }));
  }

  // 檢驗機關清單名稱選單
  get formattedVerificationOrgNameOptions() {
    return this.verificationOptions.map(({ code, name }) => ({
      id: code,
      label: name,
      value: name,
    }));
  }

  //取得製程/逸散/外購電力類別清單
  getEmissionSelectOptions = async () => {
    this.emissionSelectOptions = [];
    try {
      const response = await getEmissionSelectOptions();
      this.emissionSelectOptions = response;
    } catch (error) {
      console.error("Error fetching list", error);
    }
  };

  //取得製程/逸散/外購電力類別選項
  getProcessFugitivePurchasedEnergyCategory = (categoryKey) => {
    const data = this.emissionSelectOptions;
    // 防呆：確認資料存在且該 key 有效
    if (!categoryKey || !data || !data[categoryKey]) {
      return [];
    }

    return data[categoryKey].options || [];
  };

  //取得電力/蒸氣來源選項
  getPowerSteamSource = (categoryKey, secondLevelValue) => {
    const data = this.emissionSelectOptions;

    // 防呆
    if (
      !categoryKey ||
      secondLevelValue === undefined ||
      !data ||
      !data[categoryKey]
    ) {
      return [];
    }

    const categoryData = data[categoryKey];
    const selectedOption = categoryData.options.find(
      (opt) => opt.value === secondLevelValue,
    );

    if (!selectedOption) return [];
    const labelKey = selectedOption.label;
    // 從 children 物件中取得對應 label 的陣列
    return categoryData.children?.[labelKey] || [];
  };

  //量測頻率(下拉)選項
  getMeasurementFrequencyOptions = async () => {
    this.measurementFrequencyOptions = [];
    try {
      const response = await getMeasurementFrequencyOptionInfo();
      this.measurementFrequencyOptions = response;
    } catch (error) {
      console.error("Error fetching measurement frequency options", error);
    }
  };
  get formattedMeasurementFrequencyOptions() {
    return this.measurementFrequencyOptions.map(({ index, code, name }) => ({
      id: index,
      label: name,
      value: code,
    }));
  }

  //燃料熱值/碳含量來源(下拉)選項
  getFuelHeatCarbonSourceLookupOptions = async () => {
    this.fuelHeatCarbonSourceLookupOptions = [];
    try {
      const response = await getFuelHeatCarbonSourceLookup();
      this.fuelHeatCarbonSourceLookupOptions = response;
    } catch (error) {
      console.error("Error fetching list", error);
    }
  };

  get formattedFuelHeatCarbonSourceLookupOptions() {
    return this.fuelHeatCarbonSourceLookupOptions.map(
      ({ index, code, name }) => ({
        id: index,
        label: name,
        value: code,
      }),
    );
  }

  ////實驗室/檢測機構認證資格(下拉)選項
  getLabAccreditationQualificationLookupOptions = async () => {
    this.labAccreditationQualificationLookupOptions = [];
    try {
      const response = await getLabAccreditationQualificationLookup();
      this.labAccreditationQualificationLookupOptions = response;
    } catch (error) {
      console.error("Error fetching list", error);
    }
  };

  get formattedLabAccreditationQualificationLookupOptions() {
    return this.labAccreditationQualificationLookupOptions.map(
      ({ index, code, name }) => ({
        id: index,
        label: name,
        value: code,
      }),
    );
  }

  //檢測方法(下拉)選項
  getTestingMethodLookupOptions = async () => {
    this.testMethodLookup = [];
    try {
      const response = await getTestingMethodLookup();
      this.testMethodLookup = response;
    } catch (error) {
      console.error("Error fetching list", error);
    }
  };

  get formattedTestingMethodLookupOptions() {
    return this.testMethodLookup.map(({ index, code, name }) => ({
      id: index,
      label: name,
      value: code,
    }));
  }

  /////////////////////////////事業基本資料
  //初始化:產生預設的basicInfo資料
  _generateDefaultBasicInfo() {
    return {
      year: this.selectedYear,
      rootId: commonStore.scopeId,
      control_no: "",
      organization_name: "",
      authority_name: "",
      authority_code: "",
      authority_certificate_no: "",
      unified_business_no: "",
      owner_name: "",
      industry_code: "",
      industry_category_name: "",
      contact_name: "",
      contact_phone: "",
      contact_email: "",
      contact_fax: "",
      registration_type: "依法盤查登錄",
      registered_industry: "",
      registered_condition: "",
      verified_flag: 0,
      verified_org_code: "",
      verified_org_name: "",
      remark: "",
    };
  }

  //初始化:驗證規則
  _getBasicInfoValidationRules = () => ({
    // control_no: {
    //   required: true,
    //   label: "管制編號",
    //   minLength: 8,
    //   minLengthMessage: "請依據申請帳號之管制編號填入8碼",
    // },
    // authority_name: { required: true, label: "所屬目的事業主管機關" },
    unified_business_no: {
      required: true,
      label: "統一編號",
      pattern: /^\d{8}$/,
      patternMessage: "統一編號必須是8位數字",
    },
    owner_name: { required: true, label: "負責人姓名" },
    contact_name: { required: true, label: "聯絡人姓名" },
    contact_email: { required: true, label: "聯絡人電子信箱", isEmail: true }, // 標記為 email
    contact_phone: { required: true, label: "聯絡人電話" },
  });

  _handleBasicInfoDataLoading = (value) => {
    this.basicInfoDataLoading = value;
  };

  //通用欄位更新 (給簡單的 Input 用)
  handleInputChange = (field, value) => {
    if (this.basicInfoData) {
      this.basicInfoData[field] = value;
    }
  };

  handleIndustryChange = (selectedOption, allIndustryOptions) => {
    const selectedCode = selectedOption.id;

    const matchedIndustry = allIndustryOptions.find(
      (item) => item.code === selectedCode,
    );

    if (matchedIndustry && this.basicInfoData) {
      // 一次更新兩個欄位
      this.basicInfoData.industry_code = matchedIndustry.code;
      this.basicInfoData.industry_category_name = matchedIndustry.name;
    }
  };

  handleAuthorityChange = (selectedOption, allAuthorityOptions) => {
    const selectedCode = selectedOption.id;

    const matchedAuthority = allAuthorityOptions.find(
      (item) => item.code === selectedCode,
    );

    if (matchedAuthority && this.basicInfoData) {
      // 一次更新兩個欄位
      this.basicInfoData.authority_code = matchedAuthority.code;
      this.basicInfoData.authority_name = matchedAuthority.name;
    }
  };

  //  新增：處理「納管行業」變更 (需清空納管條件)
  handleRegisteredIndustryChange = (value) => {
    if (this.basicInfoData) {
      this.basicInfoData.registered_industry = value;
      // 邏輯：當納管行業改變，下面的條件要重置
      this.basicInfoData.registered_condition = "";
    }
  };

  handleVerifiedOrgChange = (selectedOption, allVerificationOptions) => {
    const selectedCode = selectedOption.id;

    const matchedVerification = allVerificationOptions.find(
      (item) => item.code === selectedCode,
    );

    if (matchedVerification && this.basicInfoData) {
      // 一次更新兩個欄位
      this.basicInfoData.verified_org_code = matchedVerification.code;
      this.basicInfoData.verified_org_name = matchedVerification.name;
    }
  };

  //////取得List
  getBasicListData = async () => {
    try {
      this._handleBasicInfoDataLoading(true);
      const data = await getSchoolBasicInfo(
        commonStore.scopeId,
        this.selectedYear,
      );
      // 如果 data 存在且不是空陣列，使用第一筆資料；否則使用預設值
      if (data && data.length > 0) {
        this.basicInfoData = data[0];
        this.basicInfoId = data[0].id;
      } else {
        this.basicInfoData = this._generateDefaultBasicInfo();
        this.basicInfoId = null;
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      // 發生錯誤時也重置為預設值
      this.basicInfoData = this._generateDefaultBasicInfo();
      this.basicInfoId = null;
    } finally {
      this._handleBasicInfoDataLoading(false);
    }
  };

  //單一驗證欄位
  validateBasicInfoField = (fieldName, t) => {
    const rules = this._getBasicInfoValidationRules();
    const rule = rules[fieldName];
    if (!rule) return null;

    const value = this.basicInfoData[fieldName];
    let errorMsg = null;

    // 1. 必填驗證
    if (rule.required && (!value || String(value).trim() === "")) {
      errorMsg = `${t(rule.label)} ${t("is required. Please fill in the required fields")}`;
    }

    // 2. Email 格式
    else if (rule.isEmail && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        errorMsg = t("Please enter a valid email address format");
      }
    }

    // 3. 其他規則 (僅當有值時)
    else if (value && String(value).trim() !== "") {
      if (rule.minLength && String(value).trim().length < rule.minLength) {
        errorMsg =
          rule.minLengthMessage ||
          `${t(rule.label)}${t("length is insufficient")}`;
      }
      if (rule.pattern && !rule.pattern.test(String(value).trim())) {
        errorMsg =
          rule.patternMessage || `${t(rule.label)}${t("format is incorrect")}`;
      }
    }
    return errorMsg;
  };

  //全部驗證欄位
  validateBasicInfoFieldAll = (t) => {
    const rules = this._getBasicInfoValidationRules();
    let isValid = true;
    let firstErrorMsg = null; // 收集第一個錯誤訊息

    // 清空舊錯誤
    this.clearBasicErrors();

    Object.keys(rules).forEach((fieldName) => {
      const error = this.validateBasicInfoField(fieldName, t);
      if (error) {
        isValid = false;
        if (!firstErrorMsg) firstErrorMsg = error; // 記錄第一個錯誤
      }
    });

    return { isValid, firstErrorMsg };
  };

  // 清除錯誤
  clearBasicErrors = () => {
    this.basicInfoValidationErrors = {};
  };

  //儲存基本資料
  handleBasicInfoSave = async (t) => {
    const { isValid, firstErrorMsg } = this.validateBasicInfoFieldAll(t);

    if (!isValid) {
      console.warn("驗證失敗");
      // handleAPIError("資料填寫有誤，請重新檢查欄位");
      showErrorToast(firstErrorMsg); // 顯示第一個錯誤訊息
      return false; // 回傳失敗
    }
    // 所有驗證通過，執行儲存
    this._handleBasicInfoDataLoading(true);
    try {
      if (this.basicInfoId) {
        await updateSchoolBasicInfo(this.basicInfoId, this.basicInfoData);
      } else {
        //如果沒有id,表示是新建資料
        await addSchoolBasicInfo(this.basicInfoData);
      }
    } catch (error) {
      console.error("儲存失敗：", error);
    } finally {
      this._handleBasicInfoDataLoading(false);
    }
  };

  /////////////////////////////邊界設定
  _handleBoundarySiteDataLoading = (value) => {
    this.boundarySiteDataLoading = value;
  };

  ////////設定BoundarySite
  getBoundarySiteData = async () => {
    this._handleBoundarySiteDataLoading(true);
    this.boundarySiteData = [];
    try {
      // 清空修改和驗證
      this._handleClearModifications();
      const response = await getBoundarySite(
        commonStore.rootId,
        this.selectedYear,
      );
      this.boundarySiteData = response;
    } catch (err) {
      this.boundarySiteData = [];
      // handleAPIError("Get Boundary Site Data Fail!", err);
    } finally {
      this._handleBoundarySiteDataLoading(false);
    }
  };

  /////////更新BoundarySite修改過的列
  updateField = (rowId, field, value) => {
    // const idIsZeroKey=
    const originalRow = this.boundarySiteData.find((item) => {
      const itemKey =
        item._tempKey || (item.id !== 0 ? item.id : `${item.id}_${item.no}`);
      return itemKey === rowId;
    });

    this.modifiedRows = {
      ...this.modifiedRows,
      [rowId]: {
        ...originalRow,
        ...this.modifiedRows[rowId],
        [field]: value,
      },
    };

    console.log("this.modifiedRows", this.modifiedRows);
    // 當欄位更新時，清除該欄位的錯誤狀態
    this.clearFieldError(rowId, field);
  };

  //////更新BoundarySite中連動的下拉式清單
  updateAuthorityField = (rowId, selectedOption) => {
    if (!selectedOption) return;
    const selectedCode = selectedOption.id;

    const matchedAuthority = this.authorityOptions.find(
      (item) => item.code === selectedCode,
    );

    // 防呆：如果找不到對應資料就不處理
    if (!matchedAuthority) return;

    const originalRow = this.boundarySiteData.find((item) => {
      const itemKey =
        item._tempKey || (item.id !== 0 ? item.id : `${item.id}_${item.no}`);
      return itemKey === rowId;
    });
    this.modifiedRows = {
      ...this.modifiedRows,
      [rowId]: {
        ...originalRow, // 先展開原始資料
        ...this.modifiedRows[rowId], // 再展開已修改的資料(避免覆蓋其他欄位的修改)
        authority_code: matchedAuthority.code, // 更新代碼
        authority_name: matchedAuthority.name, // 連動更新名稱
      },
    };

    console.log("Updated modifiedRows", this.modifiedRows);
  };

  _handleSetSelectedOriginalRows = (rows) => {
    this.selectedOriginalRows = rows;
  };

  _handleSetSelectedCopiedRows = (rows) => {
    this.selectedCopiedRows = rows;
  };

  //boundarySite複製功能
  cloneOriginalRows = (selectedRows) => {
    // 根據 index 排序
    const sortedSelectedRows = [...selectedRows].sort(
      (a, b) => a.index - b.index,
    );

    // 取得要複製的列資料
    const rowsToClone = sortedSelectedRows.map(({ index, id }) => {
      const originalRow = this.boundarySiteData[index];
      // 生成唯一的臨時 ID
      const tempId = `temp_copied_${Date.now()}_${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      return {
        ...originalRow,
        id: 0, // 新的 id 由後端生成
        // companyId: tempId, // 新的 companyId 由後端生成
        is_copy_from_id: id, // 標記是從哪一筆原始資料複製的
        _tempKey: tempId, // 新增臨時 key 欄位
        _isNewCopy: true,
      };
    });

    // 將複製的列加到列表最後
    this.boundarySiteData.push(...rowsToClone);
    // 將複製的列加入 modifiedRows，讓它們有綠色背景
    rowsToClone.forEach((row) => {
      this.modifiedRows = {
        ...this.modifiedRows,
        [row._tempKey]: { ...row },
      };
    });

    // return rowsToClone.length;
    return rowsToClone; // 回傳複製的列陣列
  };

  /////////存檔BoundarySite修改過的列
  handleBoundarySiteSave = async (authId) => {
    const editedData = Object.values(this.modifiedRows);
    if (editedData.length === 0) return;

    // 執行驗證
    const isValid = this.validateModifiedRows();
    if (!isValid) {
      return; // 驗證失敗，不執行儲存
    }
    this._handleBoundarySiteDataLoading(true);
    try {
      const response = await updateBoundarySite(editedData);
      // 成功後更新LIST
      await this.getBoundarySiteData();
      showSuccessToast({
        apiData: response,
        scenarioCode: MESSAGE_CODES.GUIDANCE_BOUNDARY_SITE_UPDATE_SUCCESS,
      });
      // 成功後清空
      this._handleClearModifications();
    } catch (error) {
      console.error("儲存失敗：", error);
      handleAPIError(error);
    } finally {
      this._handleBoundarySiteDataLoading(false);
    }
  };

  // 清除特定欄位的錯誤
  clearFieldError(customerId, field) {
    if (this.validationErrors[customerId]?.[field]) {
      if (Object.keys(this.validationErrors[customerId]).length === 1) {
        delete this.validationErrors[customerId];
      } else {
        delete this.validationErrors[customerId][field];
      }
    }
  }

  // 驗證被修改過的列
  validateModifiedRows = () => {
    const errors = {};
    const missingFieldsList = [];

    // 只驗證被修改過的列
    Object.keys(this.modifiedRows).forEach((customerId) => {
      const rowData = this.modifiedRows[customerId];
      const rowErrors = {};

      this.requiredFields.forEach(({ key, label }) => {
        const value = rowData[key];
        // 檢查是否為空值
        if (
          value === null ||
          value === undefined ||
          value === "" ||
          (typeof value === "string" && value.trim() === "")
        ) {
          rowErrors[key] = true;
          missingFieldsList.push(
            `${rowData.customer_company_name || "未命名"}: ${label}`,
          );
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        errors[customerId] = rowErrors;
      }
    });

    this.validationErrors = errors;

    if (Object.keys(errors).length > 0) {
      handleAPIError(
        "Please fill in all required fields.",
        "Please fill in all required fields.",
      );
      return false;
    }

    // 之後寫複雜版
    //如果有錯誤，顯示 alert
    // if (Object.keys(errors).length > 0) {
    //   alert(`請填寫以下必填欄位：\n\n${missingFieldsList.join("\n")}`);
    //   return false;
    // }

    return true;
  };

  // 驗證選中要複製的列
  //之後要改成validationErrors
  validateSelectedRowsForClone = (selectedRows) => {
    const errors = {};
    const missingFieldsList = [];

    selectedRows.forEach(({ index, id }) => {
      const rowData = this.boundarySiteData[index];
      const rowErrors = {};

      this.requiredFields.forEach(({ key, label }) => {
        const value = rowData[key];
        // 檢查是否為空值
        if (
          value === null ||
          value === undefined ||
          value === "" ||
          (typeof value === "string" && value.trim() === "")
        ) {
          rowErrors[key] = true;
          missingFieldsList.push(
            `${rowData.customer_company_name || "未命名"}: ${label}`,
          );
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        errors[id] = rowErrors;
      }
    });

    if (Object.keys(errors).length > 0) {
      // 顯示具體缺少哪些欄位
      // const errorMessage = `以下資料有必填欄位未填寫，無法複製：\n${missingFieldsList.join("\n")}`;
      handleAPIError(
        "Copy failed. Please fill in the required fields.",
        "Copy failed. Please fill in the required fields.",
      );
      return false;
    }

    return true;
  };

  // 清空修改
  _handleClearModifications = () => {
    this.modifiedRows = {};
    this.validationErrors = {};
    console.log("清空修改", this.modifiedRows);
  };

  /////檢查是否還有未存檔的列
  isGuidanceForEmissionActivityEdit = () => {
    return (
      Object.keys(this.modifiedRows).length > 0 ||
      this.newEmissionSourceModifiedRows.size > 0 ||
      this.activityDataModifiedRows.size > 0 ||
      this.testingMethodAndDateModifiedRows.size > 0 ||
      this.unitDepartmentModifiedRows.size > 0
    );
  };

  // 檢查特定欄位是否有錯誤
  hasFieldError = (customerId, field) => {
    return this.validationErrors[customerId]?.[field] || false;
  };

  ////////設定單位和部門
  getUnitDepartmentData = async (id, year) => {
    this._handleUnitDepartmentDataLoading(true);
    this.unitDepartmentData = [];
    try {
      // 清空修改和驗證
      // this._handleClearModifications();
      const response = await getUnitDepartment(id, year);
      this.unitDepartmentData = response;
    } catch (err) {
      this.unitDepartmentData = [];
      // handleAPIError("Get Boundary Site Data Fail!", err);
    } finally {
      this._handleUnitDepartmentDataLoading(false);
    }
  };

  //  創建空白行
  createEmptyUnitDepartmentRow = (selectedYear, authId) => ({
    // year: selectedYear,
    id: null,
    _tempId: `temp_${Date.now()}_${Math.random()}`,
    rootId: authId,
    companyId: "",
    customer_company_no: "",
    customer_company_name: "",
    name: "",
    users: [],
  });

  //  新增空白行
  addUnitDepartmentRow = (selectedYear, authId) => {
    const newRow = this.createEmptyUnitDepartmentRow(selectedYear, authId);
    this.unitDepartmentData.unshift(newRow);
  };

  // 獲取行的唯一識別碼 (優先使用 id,沒有則用 _tempId)
  getUnitDepartmentRowKey = (row) => {
    return row.id !== null ? `id_${row.id}` : `temp_${row._tempId}`;
  };

  //  更新單一欄位
  updateUnitDepartmentField = (index, field, value) => {
    if (!this.unitDepartmentData[index]) {
      console.error("無效的索引", index);
      return;
    }

    const row = this.unitDepartmentData[index];
    // 直接修改屬性，MobX 會自動追蹤變更
    this.unitDepartmentData[index][field] = value;

    // 使用 rowKey 追蹤
    const rowKey = this.getUnitDepartmentRowKey(row);
    this.addUnitDepartmentModifiedRow(rowKey);

    // 清除該列該欄位的錯誤
    if (this.unitDepartmentErrors[rowKey]?.[field]) {
      delete this.unitDepartmentErrors[rowKey][field];
      if (Object.keys(this.unitDepartmentErrors[rowKey]).length === 0) {
        delete this.unitDepartmentErrors[rowKey];
      }
    }
  };

  //  批量更新欄位（用於 Department變更）
  updateUnitDepartmentFields = (index, updates) => {
    if (!this.unitDepartmentData[index]) {
      console.error("無效的索引", index);
      return;
    }

    const row = this.unitDepartmentData[index];
    Object.keys(updates).forEach((key) => {
      this.unitDepartmentData[index][key] = updates[key];
    });

    const rowKey = this.getUnitDepartmentRowKey(row);
    this.addUnitDepartmentModifiedRow(rowKey);
  };
  //  添加修改標記
  addUnitDepartmentModifiedRow = (rowKey) => {
    this.unitDepartmentModifiedRows.add(rowKey);
    console.log(
      "添加後 unitDepartmentModifiedRows",
      this.unitDepartmentModifiedRows,
    );
  };

  //  移除修改標記
  removeUnitDepartmentModifiedRow = (rowKey) => {
    this.unitDepartmentModifiedRows.delete(rowKey);
    console.log(
      "刪除後有unitDepartmentModifiedRows",
      this.unitDepartmentModifiedRows,
    );
  };

  //  清除所有修改標記
  clearUnitDepartmentModifiedRows = () => {
    this.unitDepartmentModifiedRows.clear();
    this.unitDepartmentErrors = {};
  };

  //檢查是否有修改
  isUnitDepartmentRowModified = (row) => {
    const rowKey = this.getUnitDepartmentRowKey(row);
    return this.unitDepartmentModifiedRows.has(rowKey);
  };

  ////////更新目前選擇的列
  _handleSetSelectedUnitDepartmentRows = (value) => {
    this.selectedUnitDepartmentRows = value;
    console.log("selectedUnitDepartmentRows", value);
  };

  //  驗證必填欄位
  validateUnitDepartment = () => {
    const requiredFields = [
      "customer_company_no",
      "customer_company_name",
      "name",
      // "users",
    ];
    const newErrors = {};
    this.unitDepartmentModifiedRows.forEach((rowKey) => {
      // 找到對應的 row
      const row = this.unitDepartmentData.find(
        (r) => this.getUnitDepartmentRowKey(r) === rowKey,
      );

      if (!row) return;

      const rowErrors = {};
      requiredFields.forEach((field) => {
        if (!row[field] || row[field] === "" || row[field] === 0) {
          rowErrors[field] = "此欄位為必填";
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        newErrors[rowKey] = rowErrors;
      }
    });

    this.unitDepartmentErrors = newErrors;
    return Object.keys(newErrors).length === 0;
  };

  // ===== 送給後端前處理資料 =====
  prepareUnitDepartmentDataForBackend = () => {
    return this.unitDepartmentData.map((row) => {
      const { _tempId, ...dataForBackend } = row;
      return dataForBackend;
    });
  };

  /////////存檔unitDepartment修改過的列
  saveUnitDepartment = async (rootId, selectedYear, userId) => {
    if (this.unitDepartmentModifiedRows.size === 0) {
      throw new Error("沒有需要儲存的變更");
    }

    if (!this.validateUnitDepartment()) {
      throw new Error("請填寫所有必填欄位");
    }

    // 根據 rowKey 找出對應的 row
    const modifiedRowsData = Array.from(this.unitDepartmentModifiedRows)
      .map((rowKey) => {
        return this.unitDepartmentData.find(
          (row) => this.getUnitDepartmentRowKey(row) === rowKey,
        );
      })
      .filter(Boolean) // 過濾掉 undefined
      .map((row) => {
        // 移除 _tempId
        const { _tempId, ...dataForBackend } = row;
        return dataForBackend;
      });

    try {
      this._handleUnitDepartmentDataLoading(true);
      await updateUnitDepartment(modifiedRowsData, selectedYear, userId);

      // 重新獲取數據
      await this.getUnitDepartmentData(rootId, selectedYear);

      // 清除修改標記和錯誤
      this.clearUnitDepartmentModifiedRows();
      // this.newEmissionSourceErrors = {};

      return { success: true };
    } catch (error) {
      console.error("儲存失敗：", error);
      throw error;
    } finally {
      this._handleUnitDepartmentDataLoading(false);
    }
  };

  /////////////////////////////排放源設定
  //////排放源設定loading
  _handleEmissionSettingDataLoading = (value) => {
    this.emissionSettingDataLoading = value;
  };

  ////////取得排放源設定
  getEmissionSettingData = async (orgId, companyId, year) => {
    this._handleEmissionSettingDataLoading(true);
    this.emissionSettingData = [];
    try {
      const response = await getEmissionSetting(orgId, companyId, year);
      this.emissionSettingData = response;
      // console.log("this.emissionSettingData", response);
    } catch (err) {
      this.emissionSettingData = [];
      handleAPIError(err);
    } finally {
      this._handleEmissionSettingDataLoading(false);
    }
  };

  /////////////////////////////活動清單(新增排放源，我的排放源)
  //////活動清單(新增排放源，我的排放源)loading
  _handleEmissionActivityListLoading = (value) => {
    this.emissionActivityListLoading = value;
  };

  //選項
  //之後加新增排放源的下拉式選單

  //////取得活動清單(新增排放源，我的排放源)
  getEmissionActivityList = async (orgId, companyId, year) => {
    this._handleEmissionActivityListLoading(true);
    this.emissionActivityList = [];
    try {
      // 如果 companyId 是 "all",改為空值
      const actualCompanyId = companyId === "all" ? "" : companyId;
      const response = await getActivityList(orgId, actualCompanyId, year);
      this.emissionActivityList = response;
      console.log("this.emissionSettingData", response);
      this.initNewEmissionSourceCurrentList();
      this.initCurrentActivityDataList();
      this.initCurrentTestingMethodAndDate();
    } catch (err) {
      this.emissionActivityList = [];
      handleAPIError(err);
    } finally {
      this._handleEmissionActivityListLoading(false);
    }
  };

  ///新增排放源，排放源鑑別的資料
  get newEmissionSourceList() {
    // MobX 會追蹤 this.list
    return this.emissionActivityList.map((item) => ({
      /////共有欄位
      id: item.id,
      _tempId: item._tempId, // 保留 _tempId (如果有的話)
      year: item.year,
      rootId: item.rootId,
      companyId: item.companyId,
      customer_company_name: item.customer_company_name,
      category: item.category,
      activityId: item.activityId,
      userId: item.userId,
      custodian_name: item.custodian_name,
      //////
      customer_company_no: item.customer_company_no,
      department_id: item.department_id,
      department_name: item.department_name,
      equipment_no: item.equipment_no,
      property_no: item.property_no,
      equipment_code: item.equipment_code,
      equipment_name: item.equipment_name,
      equipment_detail: item.equipment_detail,
      equipment_quantity: item.equipment_quantity,
      equipment_desc: item.equipment_desc,
      material_code: item.material_code,
      material_name: item.material_name,
      material_type_code: item.material_type_code,
      equipment_type_code: item.equipment_type_code,
      refrigerantCalculationId: item.refrigerantCalculationId,
      customFugitiveEmissionRate: item.customFugitiveEmissionRate,
      process_fugitive_purchased_energy_category:
        item.process_fugitive_purchased_energy_category, //製程逸散購買能源類別
      electricity_steam_source: item.electricity_steam_source, //電力蒸汽來源
      is_biogenic_fuel: item.is_biogenic_fuel, //是否屬生質燃料
      other_process_fugitive_category_desc:
        item.other_process_fugitive_category_desc, //其他製程逸散類別說明
      process_emission_removal_rate: item.process_emission_removal_rate, //製程排放去除率%
    }));
  }

  ///活動數據的資料
  get ActivityDataList() {
    // MobX 會追蹤 this.list
    return this.emissionActivityList.map((item) => ({
      /////共有欄位
      id: item.id,
      year: item.year,
      rootId: item.rootId,
      companyId: item.companyId,
      customer_company_name: item.customer_company_name,
      category: item.category,
      activityId: item.activityId,
      userId: item.userId,
      custodian_name: item.custodian_name,
      equipment_code: item.equipment_code, //設備代碼
      material_code: item.material_code, //物質代碼
      //////
      department_name: item.department_name, //單位/部門
      department_id: item.department_id,
      equipment_no: item.equipment_no, //設備自定義編號
      equipment_name: item.equipment_name, //設備名稱
      equipment_desc: item.equipment_desc, //自定義設備名稱
      equipment_detail: item.equipment_detail, //自定義設備備註
      material_name: item.material_name,
      is_used_current_year: item.is_used_current_year, //今年度有無使用該項設備
      rawData: item.rawData, //活動數據
      activity_share_percent: item.activity_share_percent ?? 100, //預設活動數據分配比率100%
      dataUnit: item.dataUnit, //活動數據單位
      data_source: item.data_source, //數據來源
      storage_unit: item.storage_unit, //保存單位
      measurement_frequency: item.measurement_frequency, //量測頻率
      measurement_device: item.measurement_device, //"量測儀器",
      sourceEF: item.sourceEF, //排放係數來源
      nameEF: item.nameEF, //排放係數名稱
      fuel_heat_carbon_source: item.fuel_heat_carbon_source,
      carbon_content: item.carbon_content, //碳含量
      fuel_heat_carbon_data_source: item.fuel_heat_carbon_data_source, //燃料熱值碳含量資料來源
    }));
  }

  ///測試方法及日期的資料
  get TestingMethodAndDateList() {
    // MobX 會追蹤 this.list
    return this.emissionActivityList.map((item) => ({
      /////共有欄位
      id: item.id,
      year: item.year,
      rootId: item.rootId,
      companyId: item.companyId,
      customer_company_name: item.customer_company_name,
      category: item.category,
      activityId: item.activityId,
      userId: item.userId,
      custodian_name: item.custodian_name,
      equipment_code: item.equipment_code, //設備代碼
      material_code: item.material_code, //物質代碼
      //////
      department_name: item.department_name,
      department_id: item.department_id,
      equipment_name: item.equipment_name,
      equipment_no: item.equipment_no, //設備自定義編號
      equipment_detail: item.equipment_detail,
      equipment_desc: item.equipment_desc, //設備名稱備註
      material_name: item.material_name,
      lab_name: item.lab_name,
      lab_certification: item.lab_certification,
      low_heating_carbon_value: item.low_heating_carbon_value, //低位熱值/碳含量
      parameter_value: item.parameter_value, //參數數值
      parameter_unit: item.parameter_unit, // "參數單位",
      method_code: item.method_code,
      method_name: item.method_name,
      test_date_start: item.test_date_start,
      test_date_end: item.test_date_end,
      test_frequency: item.test_frequency,
      test_frequency_unit: item.test_frequency_unit, //檢測頻率單位
    }));
  }

  //初始化 NewEmissionSource 當前列表
  initNewEmissionSourceCurrentList = () => {
    this.newEmissionSourceCurrentList =
      this.newEmissionSourceList.length > 0
        ? [...this.newEmissionSourceList]
        : [];
  };

  //  創建空白行
  createEmptyNewEmissionSourceRow = (selectedYear, authId) => ({
    year: selectedYear,
    id: null, // 後端要求新增列 id 為 null
    _tempId: `temp_${Date.now()}_${Math.random()}`, // 前端臨時識別碼
    rootId: authId,
    companyId: "",
    customer_company_no: "",
    category: "",
    activityId: "",
    userId: "",
    custodian_name: "",
    department_id: "",
    department_name: "",
    equipment_no: "",
    property_no: "",
    equipment_code: "",
    equipment_name: "",
    equipment_detail: "",
    equipment_quantity: "",
    equipment_desc: "",
    material_code: "",
    material_name: "",
    refrigerantCalculationId: "",
    customFugitiveEmissionRate: "",
    process_fugitive_purchased_energy_category: "",
    electricity_steam_source: "",
    is_biogenic_fuel: "",
    other_process_fugitive_category_desc: "",
    process_emission_removal_rate: "",
  });

  //  新增空白行
  addNewEmissionSourceRow = (selectedYear, authId) => {
    const newRow = this.createEmptyNewEmissionSourceRow(selectedYear, authId);
    this.newEmissionSourceCurrentList.unshift(newRow);
  };

  // ===== 獲取行的唯一識別碼 =====
  getNewEmissionSourceRowKey = (row) => {
    return row.id !== null ? `id_${row.id}` : `temp_${row._tempId}`;
  };

  //  更新單一欄位
  updateNewEmissionSourceField = (index, field, value) => {
    if (!this.newEmissionSourceCurrentList[index]) {
      console.error("無效的索引", index);
      return;
    }

    const row = this.newEmissionSourceCurrentList[index];
    this.newEmissionSourceCurrentList[index] = {
      ...row,
      [field]: value,
    };

    const rowKey = this.getNewEmissionSourceRowKey(row);
    this.addNewEmissionSourceModifiedRow(rowKey);

    // 清除該列該欄位的錯誤
    if (this.newEmissionSourceErrors[rowKey]?.[field]) {
      delete this.newEmissionSourceErrors[rowKey][field];
      if (Object.keys(this.newEmissionSourceErrors[rowKey]).length === 0) {
        delete this.newEmissionSourceErrors[rowKey];
      }
    }
  };

  //  批量更新欄位（用於 Department, Equipment, Material 變更）
  updateNewEmissionSourceFields = (index, updates) => {
    if (!this.newEmissionSourceCurrentList[index]) {
      console.error("無效的索引", index);
      return;
    }

    const row = this.newEmissionSourceCurrentList[index];
    this.newEmissionSourceCurrentList[index] = {
      ...row,
      ...updates,
    };

    const rowKey = this.getNewEmissionSourceRowKey(row);
    this.addNewEmissionSourceModifiedRow(rowKey);
  };
  //  添加修改標記
  addNewEmissionSourceModifiedRow = (rowKey) => {
    this.newEmissionSourceModifiedRows.add(rowKey);
    console.log(
      "添加後有newEmissionSourceModifiedRows",
      this.newEmissionSourceModifiedRows,
    );
  };

  //  移除修改標記
  removeNewEmissionSourceModifiedRow = (rowKey) => {
    this.newEmissionSourceModifiedRows.delete(rowKey);
    console.log(
      "刪除後有newEmissionSourceModifiedRows",
      this.newEmissionSourceModifiedRows,
    );
  };

  //  清除所有修改標記
  clearNewEmissionSourceModifiedRows = () => {
    this.newEmissionSourceModifiedRows.clear();
    this.newEmissionSourceErrors = {};
  };

  // ===== 檢查是否被修改 =====
  isNewEmissionSourceRowModified = (row) => {
    const rowKey = this.getNewEmissionSourceRowKey(row);
    return this.newEmissionSourceModifiedRows.has(rowKey);
  };

  //  複製選中的行
  cloneNewEmissionSourceRows = (selectedRows) => {
    // 取得要複製的列資料
    const rowsToClone = selectedRows.map((selectedRow) => {
      return {
        ...selectedRow,
        id: null, // 複製的行 id 設為 null
        _tempId: `temp_${Date.now()}_${Math.random()}`,
        activityId: "",
      };
    });

    // 將複製的列加到列表最前面
    this.newEmissionSourceCurrentList.unshift(...rowsToClone);

    // 將複製的列加入 modifiedRows
    rowsToClone.forEach((clonedRow) => {
      const rowKey = this.getNewEmissionSourceRowKey(clonedRow);
      this.addNewEmissionSourceModifiedRow(rowKey);
    });

    return rowsToClone.length;
  };

  //  驗證必填欄位
  validateNewEmissionSource = () => {
    const requiredFields = [
      "customer_company_no",
      "customer_company_name",
      "department_name",
      "equipment_no",
      "equipment_code",
      "equipment_name",
      "equipment_quantity",
      "material_code",
      "material_name",
      "category",
      "is_biogenic_fuel",
      // "userId",
    ];

    const newErrors = {};
    this.newEmissionSourceModifiedRows.forEach((rowKey) => {
      // 找到對應的 row
      const row = this.newEmissionSourceCurrentList.find(
        (r) => this.getNewEmissionSourceRowKey(r) === rowKey,
      );

      if (!row) return;

      const rowErrors = {};
      requiredFields.forEach((field) => {
        if (
          row[field] === null ||
          row[field] === undefined ||
          row[field] === ""
        ) {
          rowErrors[field] = "此欄位為必填";
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        newErrors[rowKey] = rowErrors;
      }
    });

    this.newEmissionSourceErrors = newErrors;
    return Object.keys(newErrors).length === 0;
  };

  //  保存 NewEmissionSource
  saveNewEmissionSource = async (rootId, selectedCom, selectedYear, userId) => {
    if (this.newEmissionSourceModifiedRows.size === 0) {
      throw new Error("沒有需要儲存的變更");
    }

    if (!this.validateNewEmissionSource()) {
      console.log("驗證失敗的欄位與原因：", this.newEmissionSourceErrors);
      throw new Error("請填寫所有必填欄位");
    }

    // 根據 rowKey 找出對應的 row
    const modifiedRowsData = Array.from(this.newEmissionSourceModifiedRows)
      .map((rowKey) => {
        return this.newEmissionSourceCurrentList.find(
          (row) => this.getNewEmissionSourceRowKey(row) === rowKey,
        );
      })
      .filter(Boolean) // 過濾掉 undefined
      .map((row) => {
        // 移除 _tempId
        const { _tempId, ...dataForBackend } = row;
        return dataForBackend;
      });

    try {
      this._handleEmissionActivityListLoading(true);
      await updateNewEmissionSource(modifiedRowsData, userId);

      // 重新獲取數據
      await this.getEmissionActivityList(rootId, selectedCom, selectedYear);

      // 清除修改標記和錯誤
      this.clearNewEmissionSourceModifiedRows();
      // this.newEmissionSourceErrors = {};

      return { success: true };
    } catch (error) {
      console.error("儲存失敗：", error);
      throw error;
    } finally {
      this._handleEmissionActivityListLoading(false);
    }
  };

  /////////////////////////////活動數據
  // 初始化活動數據當前列表
  initCurrentActivityDataList = () => {
    //  簡化邏輯，直接使用 getter
    this.activityDataCurrentList =
      this.ActivityDataList.length > 0 ? [...this.ActivityDataList] : [];
  };

  //////////////活動數據修改列
  addActivityDataModifiedRows = (id) => {
    this.activityDataModifiedRows.add(id);
  };
  removeActivityDataModifiedRows = (id) => {
    this.activityDataModifiedRows.delete(id);
  };
  clearActivityDataModifiedRows = () => {
    this.activityDataModifiedRows = new Set();
    this.activityDataErrors = {};
  };

  // 更新單一欄位
  updateActivityDataField = (index, field, value) => {
    console.log("activityDataCurrentList", this.activityDataCurrentList[index]);
    this.activityDataCurrentList[index] = {
      ...this.activityDataCurrentList[index],
      [field]: value,
    };
    this.addActivityDataModifiedRows(index);
    // 清除該列的錯誤
    if (this.activityDataErrors[index]) {
      delete this.activityDataErrors[index];
    }
  };

  // 驗證邏輯
  validateActivityData = () => {
    const requiredFields = [
      // "is_used_current_year",
      "activity_share_percent",
      "data_source",
      "storage_unit",
    ];

    const newErrors = {};
    this.activityDataModifiedRows.forEach((rowIndex) => {
      const row = this.activityDataCurrentList[rowIndex];
      const rowErrors = {};

      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === "" || value === null || value === undefined) {
          rowErrors[field] = "此欄位為必填";
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        newErrors[rowIndex] = rowErrors;
      }
    });

    this.activityDataErrors = newErrors;
    return Object.keys(newErrors).length === 0;
  };

  // 保存邏輯
  saveActivityData = async (rootId, selectedCom, selectedYear) => {
    if (this.activityDataModifiedRows.size === 0) {
      showErrorToast("There are no changes to save.");
      throw new Error("沒有要保存的修改");
    }

    if (!this.validateActivityData()) {
      showErrorToast("Please fill in all required fields.");
      throw new Error("請填寫所有必填欄位");
    }

    const modifiedRowsData = this.activityDataCurrentList.filter((_, index) =>
      this.activityDataModifiedRows.has(index),
    );

    try {
      this._handleEmissionActivityListLoading(true);
      await updateActivityData(modifiedRowsData);
      await this.getEmissionActivityList(rootId, selectedCom, selectedYear);
      this.clearActivityDataModifiedRows();
      // this.activityDataErrors = {};
    } finally {
      this._handleEmissionActivityListLoading(false);
    }
  };

  /////////////////////////////檢測方法及檢測日期
  // 初始化檢測方法及檢測日期當前列表
  initCurrentTestingMethodAndDate = () => {
    //  簡化邏輯，直接使用 getter
    this.testingMethodAndDateCurrentList =
      this.TestingMethodAndDateList.length > 0
        ? [...this.TestingMethodAndDateList]
        : [];
  };

  //////////////檢測方法及檢測日期修改列
  addTestingMethodAndDateModifiedRows = (id) => {
    this.testingMethodAndDateModifiedRows.add(id);
  };
  removeTestingMethodAndDateModifiedRows = (id) => {
    this.testingMethodAndDateModifiedRows.delete(id);
  };
  clearTestingMethodAndDateModifiedRows = () => {
    this.testingMethodAndDateModifiedRows = new Set();
    this.testingMethodAndDateErrors = {};
  };

  // 更新單一欄位
  updateTestingMethodAndDateField = (index, field, value) => {
    console.log(
      "testingMethodAndDateCurrentList",
      this.testingMethodAndDateCurrentList[index],
    );
    this.testingMethodAndDateCurrentList[index] = {
      ...this.testingMethodAndDateCurrentList[index],
      [field]: value,
    };
    this.addTestingMethodAndDateModifiedRows(index);
    // 清除該列的錯誤
    if (this.testingMethodAndDateErrors[index]) {
      delete this.testingMethodAndDateErrors[index];
    }
  };

  // 驗證邏輯
  validateTestingMethodAndDate = () => {
    const requiredFields = [
      "lab_name",
      "lab_certification",
      "low_heating_carbon_value",
      "parameter_value",
      "parameter_unit",
      "method_code",
      "method_name",
      "test_date_start",
      "test_date_end",
    ];

    const newErrors = {};
    this.testingMethodAndDateModifiedRows.forEach((rowIndex) => {
      const row = this.testingMethodAndDateCurrentList[rowIndex];
      const rowErrors = {};

      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === "" || value === null || value === undefined) {
          rowErrors[field] = "此欄位為必填";
        }
      });

      if (Object.keys(rowErrors).length > 0) {
        newErrors[rowIndex] = rowErrors;
      }
    });

    this.testingMethodAndDateErrors = newErrors;
    return Object.keys(newErrors).length === 0;
  };

  // 保存邏輯
  saveTestingMethodAndDate = async (rootId, selectedCom, selectedYear) => {
    if (this.testingMethodAndDateModifiedRows.size === 0) {
      showErrorToast("There are no changes to save.");
      throw new Error("沒有要保存的修改");
    }

    if (!this.validateTestingMethodAndDate()) {
      showErrorToast("Please fill in all required fields.");
      throw new Error("請填寫所有必填欄位");
    }

    const modifiedRowsData = this.testingMethodAndDateCurrentList.filter(
      (_, index) => this.testingMethodAndDateModifiedRows.has(index),
    );

    try {
      this._handleEmissionActivityListLoading(true);
      await updateTestingMethodAndDate(modifiedRowsData);
      await this.getEmissionActivityList(rootId, selectedCom, selectedYear);
      this.clearTestingMethodAndDateModifiedRows();
      // this.testingMethodAndDateErrors = {};
    } finally {
      this._handleEmissionActivityListLoading(false);
    }
  };

  //更新searchKey
  _handleSetKeywordForMyEmissionSource = (value) => {
    this.keywordForMyEmissionSource = value;
    this._handleResetEmissionSourcePage();
  };

  //更新searchKey
  _handleSetKeywordForBoundarySite = (value) => {
    this.keywordForBoundarySite = value;
  };

  _handleSetGFEADeleteModal = (value) => {
    this.isShowGFEADeleteModal = value;
  };

  ////////不同頁面在有更動前要註冊的save行為
  registerSaveHandler(fn) {
    this.pendingSaveHandler = fn;
  }

  ////////清空頁面註冊的save行為
  clearSaveHandler() {
    this.pendingSaveHandler = null;
  }

  ////////呼叫註冊的save行為
  async executeSaveHandler() {
    if (this.pendingSaveHandler) {
      await this.pendingSaveHandler();
    }
  }

  //////大專院校下載excel
  downloadGFEAExcel = async (rootId) => {
    // console.log("下載Excel", selectedPage);
    this._handleSetExcelModalLoading(true);
    if (this.selectedPage === 1) {
      await downloadBoundarySettingExcel(rootId, this.selectedYear);
    } else {
      await downloadActivityListExcel(
        this.selectedPage,
        rootId,
        this.selectedYear,
        // selectedCom
      );
    }
    this._handleSetExcelModalLoading(false);
  };

  //////大專院校上傳excel
  uploadGFEAExcel = async () => {
    this._handleSetExcelModalLoading(true);
    try {
      if (this.selectedPage === 1) {
        await uploadBoundarySiteExcel(this.file);
        await this.getBoundarySiteData();
      } else {
        await uploadActivityListExcel(this.file);
        await this.getEmissionActivityList(
          commonStore.rootId,
          this.selectedCom,
          this.selectedYear,
        );
      }
    } catch (err) {
      console.error(err);
      this._handleSetExcelModalLoading(false);
    } finally {
      this._handleSetExcelModalLoading(false);
    }
  };

  /////大量上傳excel
  bulkUploadGFEAExcel = async (type, file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "dto",
        JSON.stringify({
          importType: type,
          file: file,
        }),
      );

      const data = await importJobAPI.submitImportJob(formData);

      if (data.success) {
        return data.data?.jobId || data.jobId;
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    }
  };
}

const guidanceForEmissionActivityStore = new GuidanceForEmissionActivityStore();
export default guidanceForEmissionActivityStore;
